import { createTopicSpot, createActionSpot, createTopicSpotWithId, createActionSpotWithId } from "../../utils/spot-utils";

const spots = [
  createTopicSpot("content-1", "Spot_N_1", 150),
  createTopicSpot("content-2", "Spot_N_2", 150),
  createTopicSpot("content-3", "Spot_N_3", 150),
  createTopicSpot("content-4", "Spot_N_4", 150),
  createTopicSpot("content-5", "Spot_N_5", 150),
  createTopicSpot("content-6", "Spot_N_6", 150),
  createTopicSpot("content-7", "Spot_N_7", 150),
  createTopicSpot("content-8", "Spot_N_8", 150),
  createTopicSpot("content-9", "Spot_N_9", 150),
  createTopicSpot("content-10", "Spot_N_10", 150),
  createTopicSpotWithId("spot11", "content-11", "Spot_N_11", 150), // hidden for direct, see decorator

  // createToggleSpot("loader", [2, 1, -0.7]),
  // createActionSpot("doorOpen", [1.3, 0.9, -0.8]),


  createActionSpot("doorOpen_R", "DoorR_Trigger", 100),
  createActionSpot("doorOpen_L", "DoorL_Trigger", 100),

  createActionSpot("toolboxOpen", "Toolbox_Trigger", 100),

  createActionSpot("seatDown", "Seat_Trigger_Front", 0.1),
  createActionSpot("backrest", "Seat_Trigger_Backrest", 1000),

  createActionSpot("coolboxOpen", "Coolbox_Trigger", 100),
  createActionSpot("coolboxOpen", "Coolbox_Premium_Trigger", 100),
  createActionSpot("sunscreenDown", "SunScreen_Trigger", 0.1),
  createActionSpot("sunscreenDown", "SunScreen2_Trigger", 0.1),
  createActionSpot("hitchUp", "Trans_Trigger", 100),
  createActionSpot("hatchOpen", "Compartment_Trigger", 100),
  createActionSpot("hatchOpen", "Compartment_Premium_Trigger", 100),
  createActionSpot("steeringwheel_tilt", "SteeringWheel_Tilt_Trigger", 100),

  createActionSpot("frontLinkageUp", "FrontLinkage_Trigger", 100),
  createActionSpot("frontLinkageWorkDrive", "FrontLinkage_Work_Drive_Trigger", 100), 

  createActionSpotWithId("seatArmRestRightTilt_hide", "seatArmRestRightTilt", "Seat_Arm_Rest_Right_Tilt_Trigger", 100),
  createActionSpot("seatArmRestLeftTilt", "Seat_Arm_Rest_Left_Tilt_Trigger", 100),
  createActionSpot("seatHeadRestTilt", "Seat_Head_Rest_Tilt_Trigger", 100),
  createActionSpot("seatRotate", "Seat_Rotate_Trigger", 100),
  createActionSpot("seatRotate", "PremiumSeat_Rotate_Trigger", 100),
  createActionSpot("twinTrackTilt", "TwinTrack_Tilt_Trigger", 100),
  createActionSpot("twinTrackTilt", "Premium_TwinTrack_Tilt_Trigger", 100),


];

export default spots;
